module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./MyNoteView.js"));
	}, "MyNoteView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=MyNoteView!./src/pages/Learn/My/MyNote/MyNoteView.js
// module id = 2217
// module chunks = 367